import { Visible } from "@wix/wix-ui-icons-common";
import { Decoration_Type } from "./../ricos-types/index.js";
import { isAlwaysVisible } from "./../_shared/resolvers/is-always-visible.js";
import { isNodeSelected } from "./../_shared/resolvers/is-node-selected.js";
import { isSpoilerInText } from "./../_shared/resolvers/is-spoiler-in-text.js";
import { TEXT_BUTTON_SPOILER } from "./data-hooks.js";
const getTextButtons = () => {
  return [
    {
      id: Decoration_Type.SPOILER,
      type: "toggle",
      presentation: {
        dataHook: TEXT_BUTTON_SPOILER,
        tooltip: "Spoiler_Insert_Tooltip",
        icon: Visible
      },
      attributes: {
        visible: isAlwaysVisible,
        active: isSpoilerInText,
        disabled: isNodeSelected
      },
      command: ({ publicCommands }) => () => {
        publicCommands.toggleInlineStyle("spoiler");
        return true;
      }
    }
  ];
};
export {
  getTextButtons
};
//# sourceMappingURL=getTextButtons.js.map
